import produce from 'immer';
import {
  MINING_EVENT_ADD_BUDGET,
  MINING_EVENT_CREATE_REQUEST, MINING_EVENT_DEPOSIT_REQUEST, MINING_EVENT_INFO_DELETE_REQUEST,
  MINING_EVENT_INFO_DETAILS,
  MINING_EVENT_INFO_DETAILS_REQUEST,
  MINING_EVENT_INFO_UPDATE_REQUEST,
  MINING_EVENT_LIST,
  MINING_EVENT_LIST_REQUEST, MINING_EVENT_PAGE_RESET,
  MINING_EVENT_RESPONSE_MESSAGE, SET_MINING_EVENT_PAGINATION,
  SET_TOTAL_COUNT,
} from '../../constants/event/miningEventConstants';

const initialState = {
  list: [],
  resultCode: null,
  message: null,
  page: 1,
  pageLength: 10,
  totalCount: 0,
  searchString: '',
  searchType: '',
  scheduleInfo: [],
  logInfo: [],
};

const miningEventReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case MINING_EVENT_LIST_REQUEST:
      break;
    case MINING_EVENT_LIST:
      draft.list = action.list;
      break;
    case MINING_EVENT_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      draft.message = action.message;
      break;
    case MINING_EVENT_CREATE_REQUEST:
      break;
    case MINING_EVENT_INFO_DETAILS_REQUEST:
      break;
    case MINING_EVENT_INFO_DETAILS:
      draft.scheduleInfo = action.scheduleInfo;
      draft.logInfo = action.logInfo;
      break;
    case MINING_EVENT_INFO_UPDATE_REQUEST:
      break;
    case MINING_EVENT_INFO_DELETE_REQUEST:
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_MINING_EVENT_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.searchType = action.searchType;
      draft.searchString = action.searchString;
      break;
    case MINING_EVENT_PAGE_RESET:
      draft.page = 1;
      break;
    case MINING_EVENT_DEPOSIT_REQUEST:
      break;
    case MINING_EVENT_ADD_BUDGET:
      break;
    default:
      break;
  }
});

export default miningEventReducer;
